import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LegendComponent } from "../../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../../common/components/legend_tag_item_component";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const LegendaModal = ({
  open,
  onClose
}: Props) => {
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>
      <DialogTitle>
        Legenda
      </DialogTitle>

      <DialogContent>
        <div className="flex flex-col flex-wrap">
          <LegendComponent label="Status">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='E' />}
              label='Em Elaboração'
            />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='yellow' title='F' textColor='white' />}
              label='Finalizada'
            />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='A' />}
              label='Aprovada'
            />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='R' />}
              label='Reprovada'
            />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='blue' title='O' />}
              label='Gerou Ordem de Compra'
            />
          </LegendComponent>

          <LegendComponent label="Status Pagamento">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='PP' />}
              label='Pagamento Provisionado'
            />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='NP' />}
              label='Pagamento Não Provisionado'
            />

          </LegendComponent>
        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Fechar
              </h1>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}